import React from 'react';
import ReactDOM from "react-dom/client";
import MainApp from "./App";
import { store, persistor } from './store/store';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import './lib/reactifyCss';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorFallback from './control-components/error-boundry/error-boundry';
import { ErrorBoundary } from 'react-error-boundary'
import './custom-css/custom-style.css';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  // <React.StrictMode>
  <>
    <ErrorBoundary FallbackComponent={ErrorFallback} >
      <ToastContainer/>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <MainApp />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ErrorBoundary>

  </>
  // </React.StrictMode>

);

reportWebVitals();
